"use client";

import { APP_URL } from "@/lib/constants";
import { useAppEvents } from "@jace/insights";
import { Button } from "@jace/ui";
import { CtaButton } from "./cta-button";

interface HeaderButtonsProps {
	placement: "header" | "mobile_menu";
}

export function HeaderButtons({ placement }: HeaderButtonsProps) {
	const { emit } = useAppEvents();
	return (
		<>
			<Button
				intent="default"
				size="lg"
				asChild
				onClick={() =>
					emit({
						type: "signin_click",
						payload: { placement },
					})
				}
			>
				<a href={`${APP_URL}/signin`}>Log In</a>
			</Button>
			<CtaButton placement={placement} />
		</>
	);
}
